let Preferences = require('../mixins/user-preferences');

module.exports = {
 	mixins: [Preferences],

	data() {
		return {
			questionnaireIndex: -1,
			questionnaireDialogShowing: true,
		}
	},

  	computed: {
  		questionnaireCurrentKey() {
  			return Object.keys(this.userPreferences)[this.questionnaireIndex];
  		}
  	},

  	watch: {
  		userPreferencesSaved(val) {
  			if(val) {
	  			this.closeQuestionnaire();
	  		}
  		}
  	},

  	methods: {
  		openQuestionnaire() {
			this.questionnaireDialogShowing = true
  		},

  		closeQuestionnaire() {
  			this.questionnaireDialogShowing = false;
  		}
  	}
}
